// ** Layout Import
import UserLayout from "../../components/layouts/UserLayout";

// ** Dialog Imports
// import TagManagementDialog from "../Customers/component/TagManagement";
// import ConvertDialog from "./component/Convert";

import { ToastContainer, toast } from "react-toastify";
// import AdvancedFilter from "../Requests/component/AdvancedFilter";

import PaymentsComponent from "./component/PaymentsComponent";
import { useIndexLogic } from "./logic/index-logic";

//#endregion Custom Styled Components

const Payments = () => {

  const { IndexProps, RefundProps } = useIndexLogic();

  const {
    contentHeightFixed,
  } = IndexProps;
  //#region Permissions
  return (
    <UserLayout contentHeightFixed={contentHeightFixed} activeLink={"Payments"}>
      <PaymentsComponent 
        invoiceID={0}
      />
      {/*<ToastContainer />*/}
    </UserLayout>
  );
};

export default Payments;
